import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['image']

  async connect() {
    await import(/* webpackChunkName: 'fslightbox' */ 'fslightbox');
    document.querySelector("style.fslightbox-styles").innerText += `
      .fslightbox-container {
        background: #000;
      }
    `;
    this.imageTargets.forEach(image => {
      image.setAttribute('data-fslightbox', 'gallery');
    });
    window.refreshFsLightbox();
    window.fsLightboxInstances['gallery'].props.onClose = () => {
      this.element.dispatchEvent(new CustomEvent('close-lightbox'));
    }
  }
}
